import { useState } from "react";
import { AlertIcon, Button, GeneralDialog } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { Dialog, View } from "tamagui";

import { api } from "~/utils/api";

export const CompleteResearchDialog: React.FC<{
  researchId: string;
  trigger: React.ReactNode;
}> = ({ researchId, trigger }) => {
  const { t } = useTranslation("research");
  const [open, setOpen] = useState(false);
  const apiUtils = api.useUtils();

  const { mutate } = api.research.completeResearch.useMutation({
    onSuccess: () => {
      void apiUtils.research.list.invalidate();
      void apiUtils.research.reseachHasFinnishedFirstSlice.invalidate({
        researchId,
      });
      void apiUtils.research.slices.invalidate({
        researchId,
      });
      setOpen(false);
    },
  });

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <Dialog.Trigger data-id="invite-to-group-dialog-trigger" asChild>
        {trigger}
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay
          zIndex={0}
          key={"add-group-dialog-overlay"}
          style={{
            backgroundColor: "#6A696966",
            backdropFilter: "blur(10px)",
          }}
        />
        <GeneralDialog.Content
          data-id="invite-to-group-dialog-content"
          maxWidth={600}
          width="100%"
          paddingTop={"$5"}
        >
          <View
            paddingHorizontal={"$7.8"}
            paddingBottom={"$3"}
            gap={"$1"}
            justifyContent="center"
            alignItems="center"
          >
            <AlertIcon />

            <GeneralDialog.Title data-id="invite-to-group-dialog-title">
              {t(
                "research-list-page.research-card.complete-research-dialog.title",
              )}
            </GeneralDialog.Title>
          </View>

          <GeneralDialog.ControllArea
            gap={"$2"}
            alignItems="center"
            paddingVertical={"$3"}
          >
            <Button
              data-id="invite-to-group-dialog-submit-button"
              variant="primary"
              minWidth={180}
              maxWidth={320}
              width={"100%"}
              size="md"
              rounded="lg"
              onPress={() => mutate({ researchId })}
            >
              {t(
                "research-list-page.research-card.complete-research-dialog.complete",
              )}
            </Button>

            <GeneralDialog.Close data-id="invite-to-group-dialog-cancel-button">
              {t(
                "research-list-page.research-card.complete-research-dialog.close",
              )}
            </GeneralDialog.Close>
          </GeneralDialog.ControllArea>
        </GeneralDialog.Content>
      </Dialog.Portal>
    </Dialog>
  );
};
